"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
class EventBus {
    constructor() {
        this.subscriptions = {};
        this.isLoggingEnabled = false;
    }
    subscribe(eventName, callback) {
        if (!this.subscriptions[eventName]) {
            this.subscriptions[eventName] = [];
        }
        this.subscriptions[eventName].push(callback);
        return () => {
            this.subscriptions[eventName] = this.subscriptions[eventName].filter((cb) => cb !== callback);
        };
    }
    publish(eventName, data) {
        if (this.subscriptions[eventName]) {
            if (this.isLoggingEnabled)
                console.log(`dispatch ${eventName}`, data);
            this.subscriptions[eventName].forEach((callback) => {
                callback(data);
            });
        }
    }
    reset() {
        this.subscriptions = {};
    }
    setLogging(enabled) {
        this.isLoggingEnabled = enabled;
    }
}
exports.EventBus = EventBus;
